import React from 'react';
import { EmspView } from '../../Views';

const EMSP = () => {
    return <EmspView />;
};

export default EMSP;
